import { IsEmail, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CreateInspectionLinkDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(120)
  label!: string;

  @IsOptional()
  @OptionalStringTransform()
  @IsEmail()
  recipientEmail?: string;
}
